import { Flex } from '@televet/kibble-ui';
import { Link } from '@televet/kibble-ui/build/components/Link';
import React from 'react';

const LearnAboutTaskManager = (): JSX.Element => (
  <Flex flex={1} justifyContent="flex-end">
    <Link href="https://help.otto.vet/hc/en-us/articles/33448049280781-Flow-Task-Manager" isExternal={true}>
      Learn about Task Manager here!
    </Link>
  </Flex>
);

export default LearnAboutTaskManager;
